import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogActions, DialogContent, Typography, Box } from '@mui/material';

import { HelpLinks } from './HelpLinks';
import { BlastNiceToSeeYouImg } from '../../../assets';
import { TrialModalProps, trialModalStyles, links } from './trialModal-helpers';

export const TrialModal = ({ onClose }: TrialModalProps): React.JSX.Element => {
    return (
        <Dialog
            open
            onClose={onClose}
            closable
            PaperProps={{ sx: trialModalStyles.paper }}
        >
            <DialogContent sx={trialModalStyles.dialogContent}>
                <Box sx={trialModalStyles.innerContent}>
                    <Box
                        component='img'
                        src={BlastNiceToSeeYouImg}
                        alt='blast-nice-to-see-you'
                        sx={trialModalStyles.image}
                    />

                    <Box sx={trialModalStyles.links}>
                        <Typography
                            variant='h4'
                            sx={trialModalStyles.links.heading}
                        >
                            Need help?
                        </Typography>

                        <Typography
                            variant='body2'
                            sx={trialModalStyles.links.text}
                        >
                            We have resources to guide you.
                        </Typography>

                        <HelpLinks links={links} onClose={onClose} />
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={trialModalStyles.actions}>
                <Button
                    onClick={onClose}
                    variant='contained'
                    sx={trialModalStyles.actions.dismiss}
                >
                    Dismiss
                </Button>
            </DialogActions>
        </Dialog>
    );
};
